export default __webpack_public_path__ + "static/media/kiril.98bd06b1.jpg";